import messages from "@smartmixin/i18n/dist/translations/sr.json";

export default messages;
